import { render } from "./deploy.vue?vue&type=template&id=4e712c88"
import script from "./deploy.vue?vue&type=script&lang=ts"
export * from "./deploy.vue?vue&type=script&lang=ts"
script.render = render

export default script